module.exports = __webpack_public_path__ + "static/media/Mask-group.4cbd4938.webp";